import LazyImage from "../../../LazyImage/LazyImage";
import { DECORATOR_BAR_ERROR } from "../constants/image-constants";
import { jsx as _jsx } from "react/jsx-runtime";
var DecoratorBarError = function DecoratorBarError(_ref) {
  var alt = _ref.alt,
    className = _ref.className;
  return /*#__PURE__*/_jsx(LazyImage, {
    src: DECORATOR_BAR_ERROR,
    imgClassName: "tw-w-full tw-h-full tw-object-cover tw-min-h-1.2",
    imgxParams: {
      fit: 'clip',
      auto: 'format',
      w: 100,
      h: 100,
      q: 100
    },
    className: className,
    alt: alt,
    "aria-hidden": "true"
  });
};
export default DecoratorBarError;